export function camelCaseToWords(text: string) {
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export function convertEnumValues(obj: any) {
    return Object.keys(obj).reduce((acc, key) => ({
        ...acc,
        [key]: camelCaseToWords(obj[key])
    }), {});
}